import { tokens } from "@/shared/design-system/tokens";
import styled from "@emotion/styled";

export const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background-color: #0B3E5F;
  color: ${tokens.colors.basics[0]};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 1000;
`;

export const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 0 20px;

  @media (max-width: ${tokens.breakpoints.md - 1}px) {
    padding: 0 12px;
  }
`;

export const LogoSection = styled.div`
  font-weight: 600;
  font-size: 18px;
  display: flex;
  align-items: center;
  margin: 0 24px;

  @media (max-width: ${tokens.breakpoints.md - 1}px) {
    min-width: 0;
    margin: 0;
    gap: 8px;
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  gap: 8px;
  img {
    &:first-of-type {
      margin-right: 8px;
    }

    &:last-child {
      margin-left: 8px;
      margin-top: 2px;
    }
  }
`;

export const LogoDivider = styled.div`
  width: 1px;
  height: 48px;
  background-color: #777777;
  flex: none;
`;

export const ProfessionalName = styled.div`
  white-space: nowrap;
  font-weight: 500;
  text-align: right;
  margin-right: 8px;
  margin-left: 8px;
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 0 24px;

  @media (max-width: ${tokens.breakpoints.md - 1}px) {
    flex: 0 0 auto;
    gap: 4px;
    margin: 0;
  }
`;

export const IconWrapper = styled.button`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s, background-color 0.2s ease;
  border-radius: 4.667px;
  transform-origin: center;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;

  img {
      width: 27px; // Tamaño aumentado para el ícono de sign-out
      height: 27px;
    }

  svg path {
    stroke: ${tokens.colors.basics[0]} !important;
  }

  &.sign-out {
    width: 40px;
    height: 40px;
  }

  &:hover {
    transform: scale(1.1); // Scale al 110%
    border-radius: 4.667px;
    background: #0D3547;
  }

  &:focus-visible {
    outline: 2px solid ${tokens.colors.basics[0]};
    outline-offset: 2px;
  }
`;

export const UserSection = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;

export const AvatarWrapper = styled.div`
  width: 32px;
  height: 32px;
`;

export const DigitalHealthText = styled.span`
  padding-bottom: 1px;
  background: radial-gradient(122.46% 120.83% at 76.05% -5.13%, #a0e2f0 10%, #b090d1 40%, #7bc5d5 70.83%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 175%;
  letter-spacing: 0.138px;
`;

export const MenuToggle = styled.button`
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  padding: 0;
  border: 0;
  border-radius: ${tokens.borderRadius.lg};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  color: ${tokens.colors.basics[0]};
  cursor: pointer;

  &:hover {
    background: ${tokens.colors.blue[900]};
  }

  &:focus-visible {
    outline: 2px solid ${tokens.colors.basics[0]};
    outline-offset: 2px;
  }
`;

export const MenuIcon = styled.span`
  width: 24px;
  height: 18px;
  display: block;
  background:
    linear-gradient(currentColor, currentColor) top / 100% 2px no-repeat,
    linear-gradient(currentColor, currentColor) center / 100% 2px no-repeat,
    linear-gradient(currentColor, currentColor) bottom / 100% 2px no-repeat;
`;

